module.exports = __webpack_public_path__ + "static/unbreakable-zack-collie-2ec696852f58c0a0b21474a3a2173fd8.jpg";